import React from 'react';
import { StyledApplePay, StyledCardWrapper, StyledCreditCard, StyledGPay, StyledIconWrapper } from './CC4CashCard.styles';
import { Card } from '@sections/registry/components';
import { useTheme } from 'styled-components';
import { themeSpace } from '@utils/styledTheme.util';
import { useTranslation } from 'react-i18next';

export const CC4CashCard = () => {
  const theme = useTheme();
  const { t } = useTranslation('registry');
  const cC4CashCard = t('registryCashFundSection.cC4CashCard');
  return (
    <StyledCardWrapper>
      <Card
        eyebrow={cC4CashCard.eyebrow}
        eyebrowVariant="featureHed17"
        eyebrowColor="accentBlue4"
        title={cC4CashCard.title}
        titleVariant="calloutHed32"
        titleColor="mono1"
        wrapperStyles={{ gap: themeSpace(6)({ theme }) }}
      >
        <StyledIconWrapper>
          <StyledApplePay aria-label="apple-pay" />
          <StyledGPay aria-label="gpay" />
          <StyledCreditCard aria-label="credit-card" />
        </StyledIconWrapper>
      </Card>
    </StyledCardWrapper>
  );
};
